import { useApiQuery } from 'src/infrastructure/rest-api/useApi';
import { useCompositePartner } from '../partner/useCompositePartner';

interface UseSalesCampaignsOptions {
    enabled?: boolean;
}

export const useSalesCampaigns = (options?: UseSalesCampaignsOptions) => {
    const compositePartner = useCompositePartner();

    const { data, loading, error, refetch } = useApiQuery('/api/salescampaigns/partners/{partnerId}', 'get', {
        path: {
            partnerId: compositePartner?.id,
        },
        enabled: !!compositePartner?.id && (options?.enabled ?? true),
    });

    return { data, loading, refetch, error };
};
